import parsePhoneNumber from "../../../libphonenumber-js/es6/parsePhoneNumber.js";
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function formatPhoneNumber(value, format, metadata) {
  if (metadata || _typeof(format) === "object" && (metadata = format, format = "NATIONAL"), !value)
    return "";
  var phoneNumber = parsePhoneNumber(value, metadata);
  if (!phoneNumber)
    return "";
  switch (format) {
    case "National":
      format = "NATIONAL";
      break;
    case "International":
      format = "INTERNATIONAL";
      break;
  }
  return phoneNumber.format(format);
}
function formatPhoneNumberIntl(value, metadata) {
  return formatPhoneNumber(value, "INTERNATIONAL", metadata);
}
export {
  formatPhoneNumber as default,
  formatPhoneNumberIntl
};
//# sourceMappingURL=formatPhoneNumber.js.map
